const tierStyles = {
  starter: 'bg-blue-900/50 text-blue-300 border-blue-700',
  pro: 'bg-purple-900/50 text-purple-300 border-purple-700',
  free: 'bg-gray-800 text-gray-400 border-gray-700',
};

const tierLabels = {
  starter: 'Starter',
  pro: 'Pro',
  free: 'Free',
};

export default function TierBadge({ tier }) {
  const key = tier?.toLowerCase() || 'free';
  const style = tierStyles[key] || tierStyles.free;
  const label = tierLabels[key] || 'Free';

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${style}`}>
      {label}
    </span>
  );
}
